export default function IconPlayOutlined({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M7.75 19.3613L7.75 4.63867L20.501 12L7.75 19.3613Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
